import { render } from "./CollectorsPerformanceCard.vue?vue&type=template&id=95aaee38"
import script from "./CollectorsPerformanceCard.vue?vue&type=script&lang=js"
export * from "./CollectorsPerformanceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__